import React, { useEffect, useState } from "react";
import { API_BASE } from "../authConfig";
import "../styles/GWRAchievements.css";

const RhythmicAchievements = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 50, total: 0, totalPages: 1 });
  const [formFilters, setFormFilters] = useState({ name: "", title: "", year: "", sort: "year_desc" });
  const [filters, setFilters] = useState(formFilters);

  useEffect(() => {
    const fetchAchievements = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams({ page: String(page), pageSize: "50", sort: filters.sort });
        if (filters.name) params.set("name", filters.name);
        if (filters.title) params.set("title", filters.title);
        if (filters.year) params.set("year", filters.year);
        const response = await fetch(`${API_BASE}/getRhythmicAchieved?${params.toString()}`);
        if (!response.ok) throw new Error("Failed to fetch Gymnastics/RG");
        const data = await response.json();
        setAchievements(data.achievements || []);
        setPagination(data.pagination || { page: 1, pageSize: 50, total: 0, totalPages: 1 });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAchievements();
  }, [page, filters]);

  const updateFilter = (event) => setFormFilters((current) => ({ ...current, [event.target.name]: event.target.value }));
  const applyFilters = (event) => { event.preventDefault(); setPage(1); setFilters(formFilters); };
  const clearFilters = () => {
    const emptyFilters = { name: "", title: "", year: "", sort: "year_desc" };
    setFormFilters(emptyFilters); setFilters(emptyFilters); setPage(1);
  };

  return (
    <div className="achievements-container rhythmic-achievements-container">
      <h1 className="title">Gymnastics/RG</h1>
      <form className="achievement-filters" onSubmit={applyFilters}>
        <label>Student name<input name="name" value={formFilters.name} onChange={updateFilter} placeholder="Search a student" /></label>
        <label>Achievement title<input name="title" value={formFilters.title} onChange={updateFilter} placeholder="Search a title" /></label>
        <label>Year<input name="year" type="number" min="1900" max="2100" value={formFilters.year} onChange={updateFilter} placeholder="e.g. 2025" /></label>
        <label>Sort by<select name="sort" value={formFilters.sort} onChange={updateFilter}>
          <option value="year_desc">Newest first</option><option value="year_asc">Oldest first</option>
          <option value="name_asc">Student name: A-Z</option><option value="name_desc">Student name: Z-A</option>
          <option value="title_asc">Achievement title: A-Z</option>
        </select></label>
        <div className="filter-actions"><button type="submit">Apply filters</button><button type="button" className="secondary-filter-button" onClick={clearFilters}>Clear</button></div>
      </form>
      {loading && <p className="loading">Loading...</p>}
      {error && <p className="error">{error}</p>}
      <div className="achievements-grid">
        {!loading && !error && achievements.length === 0 && <p className="loading">No Gymnastics/RG have been published yet.</p>}
        {achievements.map((achievement) => <div key={achievement.rhythmicAchievedId} className="achievement-card rhythmic-achievement-card">
          {achievement.imageS3Url && <img src={achievement.imageS3Url} alt={achievement.title} className="achievement-image" />}
          <div className="achievement-details">
            <p className="achievement-label">Student</p>
            <h2 className="achievement-name">{achievement.name}</h2>
            <p className="achievement-label">Achievement</p>
            <p className="achievement-title">{achievement.title}</p>
            <p className="achievement-date">{achievement.recordDate}</p>
          </div>
        </div>)}
      </div>
      {!loading && !error && pagination.total > 0 && <nav className="achievement-pagination" aria-label="Rhythmic achievement pages">
        <button type="button" onClick={() => setPage((current) => current - 1)} disabled={pagination.page === 1}>Previous</button>
        <span>Page {pagination.page} of {pagination.totalPages} · {pagination.total} records</span>
        <button type="button" onClick={() => setPage((current) => current + 1)} disabled={pagination.page === pagination.totalPages}>Next</button>
      </nav>}
    </div>
  );
};

export default RhythmicAchievements;
